module.exports = __webpack_public_path__ + "static/Robert-Zhu-82597f14e2e94ef7746f07865ca72e25.png";